import { Media } from '@kiwicom/account-global-contexts';

import type { Props as HeadingProps } from './Heading';
import Heading from './Heading';

const TabTitle = (props: HeadingProps): JSX.Element => {
  return (
    <>
      <Media greaterThanOrEqual="largeMobile">
        <Heading {...props} type="title0" />
      </Media>
      <Media lessThan="largeMobile">
        <Heading {...props} type="title2" />
      </Media>
    </>
  );
};

export default TabTitle;
